import React, { Component, useState } from 'react'
import { Provider } from 'react-redux';
import { useSelector } from 'react-redux';
import { store, RootState } from '@/store';
import LoginScreen from '@/components/auth/LoginScreen';
import SignupScreen from '@/components/auth/SignupScreen';
import { useNavigate } from "react-router-dom";
import routes from '@/routes/routes.json'
type AuthMode = 'login' | 'signup';
type OnboardingStep = 'auth' | 'address' | 'bank' | 'turf-basic' | 'turf-address' | 'dashboard';


const Login: React.FC = () => {
    const navigate = useNavigate()
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);
    const { isAddressCompleted, isBankDetailsCompleted } = useSelector((state: RootState) => state.profile);

    const [authMode, setAuthMode] = useState<AuthMode>('login');
    const [currentStep, setCurrentStep] = useState<OnboardingStep>('auth');

    // React.useEffect(() => {
    // if (isAuthenticated) {
    //     if (!isAddressCompleted) {
    //         navigate(routes.vendorOnboard)
    //     } else if (!isBankDetailsCompleted) {
    //         navigate(routes.vendorOnboard)
    //     } else {
    //         // setCurrentStep('dashboard');
    //         navigate(routes.dashboard)

    //     }
    // } else {
    //     setCurrentStep('auth');
    // }
    // }, [isAuthenticated, isAddressCompleted, isBankDetailsCompleted]);

    const handleStartTurfOnboarding = () => {
        setCurrentStep('turf-basic');
    };

    const renderCurrentStep = () => {
        switch (currentStep) {
            case 'auth':
                return authMode === 'login' ? (
                    <LoginScreen onSwitchToSignup={() => setAuthMode('signup')} />
                ) : (
                    <SignupScreen onSwitchToLogin={() => setAuthMode('login')} />
                );
            default:
                return null;
        }
    };

    return renderCurrentStep();
};


export default Login;
